<!--
  The login page is only a backdrop. Auth0 Lock is the login UI — it opens over this on
  init and, with `closable: false` in core/skynet-auth.config.ts, cannot be dismissed, so
  there is nothing here to click and no card or retry button to render. Mirrors
  atlas-app-v2's auth landing page.
-->
<div class="login-backdrop">
  <img class="login-image" src="/login-background.jpg" alt="" />
</div>
